module.exports = __webpack_public_path__ + "static/media/dualMsg.068d68ee.svg";